export const SETTING_KEY_FOR_MULTI_CURRENCIES_INBOUND = 34;
export const SETTING_KEY_FOR_PHONE_NUMBER_OPTIONAL = 36;
export const SETTING_KEY_FOR_EMAIL_OPTIONAL = 37;
export const SETTING_KEY_FOR_CURRENCY_DEDUCTION = 33;
export const SETTING_KEY_FOR_TOPAZ_SIGWEB = 38;
export const SETTING_KEY_FOR_AUTO_CASHOUT = 13;